<template>
  <div class="dsfa-netcom-office-login">
    <div
      class="dsfa-sc-login1-bg"
      :style="{ backgroundImage: `url(${background})` }"
    ></div>
    <img ref="logo" v-if="logo" class="logo" :src="logo" />
    <div class="container">
      <img
        class="price-survey-code-img"
        v-show="current === 'price_survey'"
        :src="priceSurveyImg"
        @click="changeQrCode"
        :disabled="currentForgotPasswordDisabled"
      />
      <div class="container-right">
        <div class="container-right-title">
          <component
            v-for="(dom, index) in logginTitleDomList"
            :key="index"
            :is="dom.tag"
          >
            {{ dom.text }}
          </component>
        </div>
        <netcom-plan-qrcode
          v-show="showPriceImg && current === 'price_survey'"
          ref="qrcode"
        />
        <div class="container-right-tabs" v-show="!showPriceImg">
          <div
            class="tabs-tab"
            :class="{ 'tabs-tab-internal': internal }"
            :num="tabList.length"
          >
            <div
              v-for="item in tabList"
              :key="item.value"
              :class="['tabs-tab-item', current === item.value ? 'active' : '']"
              @click="current = item.value"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
          <div class="tab-panes">
            <tab-online-report
              v-if="tabListInitMap['online_report']"
              v-show="current === 'online_report'"
              :disabled="disabledTab[tabNum['online_report']] ? true : false"
            />
            <tab-department
              v-if="tabListInitMap['data_submission']"
              v-show="current === 'data_submission'"
              :disabled="disabledTab[tabNum['data_submission']] ? true : false"
              :tab-type="tabNum['data_submission']"
            />
            <tab-department
              v-if="tabListInitMap['department']"
              v-show="current === 'department'"
              :tab-type="tabNum['department']"
            />
            <tab-price-survey
              v-if="tabListInitMap['price_survey']"
              v-show="current === 'price_survey'"
              :disabled="disabledTab[tabNum['price_survey']] ? true : false"
            />
          </div>
        </div>
        <div
          v-show="!showPriceImg"
          class="forgot-password-btn"
          :disabled="currentForgotPasswordDisabled"
        >
          <el-tooltip
            popper-class="password-btn"
            effect="light"
            :disabled="current !== 'online_report'"
            content="联网直报单位请联系统计机构人员进行密码重置"
            placement="top"
          >
            <span @click="toForgotPassword">
              {{ current !== "online_report" ? "设置密码" : "忘记密码" }}
              <i class="iconfont icon-youjiantou"></i>
            </span>
          </el-tooltip>
        </div>
      </div>
      <div v-show="versionPrompt" class="container-waring">
        <i class="iconfont icon-093info"></i> {{ versionPrompt }}
        <el-button class="btn-download" @click="down">立即下载</el-button>
      </div>
    </div>
    <div class="footer">
      <div class="phone" v-show="current === 'online_report'">
        <i class="iconfont icon-lianxidianhua"></i>
        <span class="n">400-810-0166</span>
      </div>
      <div>版权所有：国家统计局</div>
      <div class="icp">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          京ICP备05034670号-2
        </a>
      </div>
      <div class="net-security">
        <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
          <img class="img" :src="icpImg" />&nbsp;&nbsp;京公网安备{{ icp }}
        </a>
      </div>
      <div class="net-security">
        <a href="https://weibo.com/nbsstatistics" target="_blank">
          <img class="img" :src="weiBoImg" alt="微博"/>&nbsp;&nbsp;微博
        </a>
      </div>
      <div class="net-security">
        <a :href="dsf.config.setting_public_internet_login_page_weixin_logo_url" target="_blank">
          <img class="img" :src="wechatImg" alt="微信"/>&nbsp;&nbsp;微信
        </a>
      </div>
    </div>
    <netcom-more
      ref="netcomPopupMore"
      v-if="isShowMore"
      @detail-more="detailMore"
      @detail-close="detailClose"
    />
    <netcom-detail-more
      ref="popupDetailMore"
      v-if="isShowDetailMore"
      :detail-params="detailParams"
      @detail-close="detailClose"
    />
    <netcom-download-page
      ref="netcomDownloadPage"
      v-if="isShowDownloadPage"
      @download-close="downloadClose"
    />
    <div
      class="dsfa-netcom-login-mask"
      v-if="showMask || isShowNetcomMask"
      @click="downloadClose()"
    ></div>
    <div v-if="popList.length">
      <popup-detail
        v-for="item in popList"
        :key="item.id"
        :ref="`PopupDetail${item.id}`"
        @maskSwitch="maskSwitch"
        :type="item.type"
      />
    </div>
  </div>
</template>

<script>
import TabOnlineReport from "./TabOnlineReport";
import TabDepartment from "./TabDepartment";
import TabPriceSurvey from "./TabPriceSurvey";
import NetcomPlanQrcode from "./TabNetcomPlanQrcode";
import NetcomMore from "./NetcomMore";
import NetcomDetailMore from "./NetcomDetailMore";
import NetcomDownloadPage from "./NetcomDownloadPage";
import PopupDetail from "./PopupDetail";

let iconPc = require("_project/assets/styles/img/login/icon-pc.png");
let iconCode = require("_project/assets/styles/img/login/icon-code.png");
export default {
  name: "NetcomOfficeLogin",
  props: {
    isShowMore: {
      type: Boolean,
      default: true,
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    wechatImg: {
      type: String,
      default() {
        return require("_project/assets/styles/img/wechat.png");
      },
    },
    weiBoImg: {
      type: String,
      default() {
        return require("_project/assets/styles/img/weibo.png");
      },
    },
    icpImg: {
      type: String,
      default() {
        return require("_project/assets/styles/img/img-icp.png");
      },
    },
    icp: {
      type: String,
      default() {
        return "11040102700142" || dsf.config.internet_login_icp;
      },
    },
    logo: {
      type: String,
      default() {
        return (
          dsf.config.setting_platform_upload_internet_logo_image ||
          require("_project/assets/styles/img/login/netcom-logo.png")
        );
      },
    },
  },
  data() {
    let isWsCa = this.$route.query.wsca == 1;
    let tableModel = this?.$route?.query?.tabModel;
    let tabList = dsf?.config?.setting_public_login_online_tab_control;
    let isInternet = this.$route.path === "/pc/internetLogin";
    let fullPath =
      "https://gmzs.stats.gov.cn/error.html?cds_id=wjpcds&app_id=tjytest&wsca=1&back_url=" +
      window.location.href;
    if (dsf.isUnDef(tabList)) {
      tabList = [
        {
          label: "联网直报",
          value: "online_report",
          appKey: "dreamH5oOkqK3"
        },
        {
          label: "部门数据报送",
          value: "data_submission",
          appKey: "dreamH5oOkqK3"
        },
        {
          label: "部门项目申报",
          value: "department",
          appKey: 'dreambSYXku12'
        },
        {
          label: "价格调查",
          value: "price_survey",
          appKey: "dreamJtqIDxG3"
        },
      ];
    }
    tabList = _.cloneDeep(tabList || []);
    // if (tableModel == 1) {
    //   let index = tabList.findIndex((t) => t.value == "user_psw");
    //   if (index < 0)
    //     tabList.unshift({
    //       label: "动态口令",
    //       value: "user_psw",
    //     });
    // }
    let tabListInitMap = {};
    tabList.forEach((it) => {
      tabListInitMap[it.value] = false;
    });
    return {
      tableModel,
      current: "",
      versionPrompt: dsf.config.setting_public_login_browser_version_tips,
      internal: dsf.config.setting_public_statis_cloud_internal,
      isWsCa,
      showTestText: dsf.config.setting_public_login_show_test_text ?? true,
      tabList,
      htmlFontSize: "50px",
      tabListInitMap,
      isInternet,
      fullPath,
      showPriceImg: false,
      priceSurveyImg: iconCode,
      isShowDetailMore: false,
      activeName: "",
      detailParams: {},
      isShowDownloadPage: false,
      isShowNetcomMask: false,
      popList: [],
      showMask: false,
      maskbg: 0,
      disabledTab: {},
      tabNum: null
    };
  },
  watch: {
    current: {
      immediate: true,
      handler: function (newVal) {
        if (!dsf.isUnDef(this.tabListInitMap[newVal])) {
          this.tabListInitMap[newVal] = true;
        }
      },
    },
  },
  components: {
    TabOnlineReport,
    TabDepartment,
    TabPriceSurvey,
    NetcomPlanQrcode,
    NetcomMore,
    NetcomDetailMore,
    NetcomDownloadPage,
    PopupDetail,
  },
  computed: {
    logginTitleDomList() {
      let logginTitle = this.$route?.meta?.loginTitle;
      if (!logginTitle) return [];
      let keys = logginTitle.match(/\$\{(.*?)\}\$/g);
      let logginTitleCopey = logginTitle;
      let logginTitleDomList = [];
      keys &&
        keys.forEach((key) => {
          let index = logginTitleCopey.indexOf(key);
          if (index > 0) {
            logginTitleDomList.push({
              tag: "span",
              text: logginTitleCopey.slice(0, index),
            });
          }
          logginTitleDomList.push({
            tag: "b",
            text: key.replace(/\$\{(.*?)\}\$/, "$1"),
          });
          logginTitleCopey = logginTitleCopey.slice(index + key.length);
        });
      if (!keys)
        logginTitleDomList = [
          {
            tag: "span",
            text: logginTitle,
          },
        ];
      return logginTitleDomList;
    },
    background() {
      return (
        dsf.config.setting_platform_upload_internet_background ||
        require("_project/assets/styles/img/login/netcom-bg.jpg")
      );
    },
    currentForgotPasswordDisabled() {
      return this.disabledTab[this.tabNum[this.current]];
    },
  },
  created() {
    document.title = dsf.config.internet_login_page_title || "统计云-登录";
    if (this.isWsCa || dsf.getCookie("KOAL_CERT_CN")) {
      if (this.tabList.findIndex((t) => t.value == "ca_auth") >= 0) {
        this.current = "ca_auth";
      }
    } else if (this.tabList?.length) {
      this.current = this.tabList[0].value;
      this.tabNum =  _.reduce(this.tabList, (result, item) => {
          result[item.value] = item.appKey
          return result;
        }, {});
    }
    this.initPopAnnouncements();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    let htmlDom = document.getElementsByTagName("html")[0];
    htmlDom.style.fontSize = "50px";
  },
  methods: {
    async initPopAnnouncements() {
      Promise.all([
        this.getPopAnnouncements(),
        this.getPopMaintenanceInfo(),
      ]).then(([res1, res2]) => {
        let popList = [];
        res1?.forEach((it) => {
          it.type = "announcement";
        });
        res2?.forEach((it) => {
          it.type = "maintenance";
        });
        popList.push(...res1);
        popList.push(...res2);
        this.popList = popList;
        this.maskbg = this.popList.length;
        this.$nextTick(() => {
          _.forEach(this.popList, (item) => {
            let pop = "PopupDetail" + item.id;
            this.$refs[pop][0].showDetail(item);
          });
        });
      });
    },
    async getPopAnnouncements() {
      return new Promise((resolve, reject) => {
        dsf.http
          .get(`/announce/getPopAnnouncements`, {})
          .done(({ data, success, message }) => {
            if (success) {
              resolve(data);
            }
          })
          .error((err) => {})
          .always(() => {});
      });
    },
    async getPopMaintenanceInfo() {
      return new Promise((resolve, reject) => {
        dsf.http
          .get(`/systemUpdate/getSystemUpdateInfos`, {})
          .done(({ data, success, message }) => {
            if (success) {
              this.disabledTab = {};
              if (data.systemPrograms.length) {
                data.systemPrograms.forEach((key) => {
                  this.disabledTab[key] = key;
                });
              }
              resolve(data.updateInfos || []);
            }
          })
          .error((err) => {})
          .always(() => {});
      });
    },
    maskSwitch(v) {
      if (!v) {
        this.maskbg--;
        if (this.maskbg == 0) {
          this.showMask = false;
        }
      } else {
        this.showMask = true;
      }
    },
    detailMore(params) {
      this.isShowDetailMore = true;
      this.isShowNetcomMask = true;
      this.detailParams = params;
    },
    downloadClose() {
      this.isShowDownloadPage = false;
      this.detailClose();
    },
    detailClose() {
      this.isShowDetailMore = false;
      this.isShowNetcomMask = false;
    },
    down() {
      this.isShowDownloadPage = true;
      this.isShowNetcomMask = true;
    },
    changeQrCode() {
      if (this.currentForgotPasswordDisabled) return;
      if (this.showPriceImg) {
        this.priceSurveyImg = iconCode;
        this.showPriceImg = false;
        this.$refs.qrcode.clearIntervalVerifyQrcode();
      } else {
        this.priceSurveyImg = iconPc;
        this.showPriceImg = true;
        this.$refs.qrcode.getQrcode();
      }
    },
    toForgotPassword() {
      if (
        this.current !== "online_report" &&
        !this.currentForgotPasswordDisabled
      ) {
        dsf.layer.openWindow("#/pc/dsfa/platformhome/forgetPassword");
      }
    },
    handleResize() {
      var swidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      if (swidth > 1920) {
        swidth = 1920;
      } else if (swidth < 1400) {
        swidth = 1400;
      }
      var prop = (swidth * 50) / 1920;
      document.querySelector("html").style.fontSize = prop + "px";
    },
  },
};
</script>
